export default __webpack_public_path__ + "locales/bg/DeleteDialog.json?hash=5a61cb334f84ec33ecf58bcae5f8eea9";